"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBearerToken = void 0;
const withBearerToken = tokenSource => {
  return async req => {
    const token = await tokenSource.getToken();
    req.headers = req.headers ?? {};
    req.headers.Authorization = `Bearer ${token.accessToken}`;
    return req;
  };
};
exports.withBearerToken = withBearerToken;
//# sourceMappingURL=oauth.js.map